<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation"  style="background-color: #183478">
  <!-- START navbar header-->
  <div class="navbar-header">
    <a class="navbar-brand" href="#/">
      <div class="brand-logo">
        <img class="img-fluid" src="./assets/img/aceleramovel_icon.png" alt="Clube Conecta" />
      </div>
      <div class="brand-logo-collapsed">
        <img class="img-fluid" src="./assets/img/aceleramovel_icon.png" alt="Clube Conecta" />
      </div>
    </a>
  </div>
  <!-- END navbar header-->
  <!-- START Left navbar-->
  <ul class="navbar-nav mr-auto flex-row">

    <li class="nav-item">
      <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
      @if (!isCollapsedText()) {
        <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize="" (click)="toggleCollapsedSideabar()">
          <em class="fas fa-bars"></em>
        </a>
      }
      <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
      <a class="nav-link sidebar-toggle d-md-none" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
        <em class="fas fa-bars"></em>
      </a>
    </li>

  </ul>
  <!-- END Left navbar-->
  <!-- START Right Navbar-->
  <ul class="navbar-nav flex-row">

    <!-- Fullscreen (only desktops)-->
    <li class="nav-item d-none d-md-block">
      <a class="nav-link" #fsbutton (click)="toggleFullScreen($event)">
        <em class="fa fa-expand"></em>
      </a>
    </li>

    <!-- START lock screen-->
    <li class="nav-item d-block">
      <a class="nav-link"  title="Lock screen" (click)="logout()">
        <em class="icon-lock"></em>
      </a>
    </li>
    <!-- END lock screen-->

  </ul>
  <!-- END Right Navbar-->

  <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
<!-- END Top Navbar-->
